var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaserSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2573 19.9718L31.4112 17.9759C30.7454 18.4113 30.0101 18.7492 29.2257 18.9696L30.0476 20.9085C30.1104 21.0567 30.1428 21.216 30.1428 21.3769V21.8308C29.7898 21.6266 29.3799 21.5097 28.9428 21.5097H10.3422C9.96404 21.5097 9.60632 21.5972 9.28814 21.753L11.9214 15.2326C12.1046 14.779 12.5449 14.482 13.0341 14.482H19.7923C19.4684 13.7346 19.2563 12.9276 19.1769 12.082H13.0341C11.5664 12.082 10.2457 12.973 9.69606 14.3339L7.00413 20.9995C6.83112 21.4279 6.74219 21.8855 6.74219 22.3476V33.648C6.74219 34.3108 7.27945 34.848 7.94219 34.848C8.60493 34.848 9.14219 34.3108 9.14219 33.648V31.7241C9.51752 31.8568 9.92143 31.9289 10.3422 31.9289H28.9428C29.3635 31.9289 29.7674 31.8568 30.1428 31.7241V33.648C30.1428 34.3108 30.68 34.848 31.3428 34.848C32.0055 34.848 32.5428 34.3108 32.5428 33.648V28.3381C32.5428 28.3351 32.5428 28.332 32.5428 28.3289V21.3769C32.5428 20.8941 32.4457 20.4163 32.2573 19.9718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3689 28.6324C13.4038 28.6324 14.2428 27.7935 14.2428 26.7586C14.2428 25.7237 13.4038 24.8848 12.3689 24.8848C11.3341 24.8848 10.4951 25.7237 10.4951 26.7586C10.4951 27.7935 11.3341 28.6324 12.3689 28.6324Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9168 28.6324C27.9517 28.6324 28.7906 27.7935 28.7906 26.7586C28.7906 25.7237 27.9517 24.8848 26.9168 24.8848C25.8819 24.8848 25.043 25.7237 25.043 26.7586C25.043 27.7935 25.8819 28.6324 26.9168 28.6324Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0754 17.5141C30.4901 17.5141 33.2582 14.7459 33.2582 11.3312C33.2582 7.91658 30.4901 5.14844 27.0754 5.14844C23.6607 5.14844 20.8926 7.91658 20.8926 11.3312C20.8926 14.7459 23.6607 17.5141 27.0754 17.5141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1561 8.59563C28.1561 7.99916 27.6726 7.51562 27.0761 7.51562C26.4796 7.51562 25.9961 7.99916 25.9961 8.59563V11.2743C25.9961 11.8708 26.4796 12.3543 27.0761 12.3543C27.6726 12.3543 28.1561 11.8708 28.1561 11.2743V8.59563Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1551 14.0702C28.1551 13.4738 27.6716 12.9902 27.0751 12.9902C26.4786 12.9902 25.9951 13.4738 25.9951 14.0702C25.9951 14.6667 26.4786 15.1502 27.0751 15.1502C27.6716 15.1502 28.1551 14.6667 28.1551 14.0702Z",
    fill: "#1C53EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaserSelected);
export default __webpack_public_path__ + "static/media/chaser-selected.983c0cf028dde8dd0e72efa0669dcc18.svg";
export { ForwardRef as ReactComponent };